import { render, staticRenderFns } from "./xfsp.vue?vue&type=template&id=41847e5e&scoped=true"
import script from "./xfsp.vue?vue&type=script&lang=js"
export * from "./xfsp.vue?vue&type=script&lang=js"
import style0 from "./xfsp.vue?vue&type=style&index=0&id=41847e5e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41847e5e",
  null
  
)

export default component.exports